"use client";

import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import React from "react";
import { ContactPageAnimator } from "../../components/contact-page-animator";
import Header from "../common/header";
import { ContactDetails } from "../../components/contact-details";
import { MapView } from "../../components/map-view";
import { InquiryForm } from "../../components/inquiry-form";
import Footer from "../common/footer";

const ContactForm = () => {
  // Keep your AOS initialization
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <ContactPageAnimator />
      <Header />

      <main className="flex-grow pt-24 md:pt-32">
        {/* Hero Section */}
        <section id="contact-hero" className="pb-12 bg-gray-50">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-neutral-800 gsap-contact-hero-title">
              Get in Touch
            </h1>
            <p className="mt-4 text-lg text-muted-foreground max-w-3xl mx-auto gsap-contact-hero-subtitle">
              {`Have a question or need help with your visa application? Our team of experts is here to assist you. Fill out the form, and we'll get back to you shortly.`}
            </p>
          </div>
        </section>

        {/* Main Contact Section */}
        <section id="contact-content" className="pb-16">
          <div className=" custom-container mx-auto px-4 max-w-7xl">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
              {/* Left Column: Contact Details + Map */}
              <div className="lg:col-span-2 space-y-8">
                <div className="gsap-contact-details" data-aos="fade-up">
                  <ContactDetails />
                </div>
                <div
                  className="h-[400px] rounded-xl overflow-hidden border gsap-contact-map"
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <MapView />
                </div>
              </div>

              {/* Right Column: Inquiry Form */}
              <div
                className="lg:col-span-3 gsap-contact-form"
                data-aos="fade-up"
                data-aos-delay={200}
              >
                <InquiryForm />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
export default ContactForm;
